import { useEffect, useState } from 'react';

const stories = [
  {
    quote: "They actually listened to me. Milo was terrified of vets before — now he walks in on his own. It's the small things: the pace, the tone, the follow-up call the next day.",
    name: 'Elena K.',
    detail: 'Pet parent to Milo, rescue mix',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20smiling%20young%20woman%20gently%20hugging%20her%20golden%20retriever%20dog%20outside%20a%20bright%20modern%20warm%20veterinary%20clinic%20on%20a%20soft%20sunny%20day%2C%20natural%20candid%20moment%2C%20warm%20off%20white%20background%2C%20real%20human%20animal%20bond%2C%20natural%20skin%20tones%2C%20intimate%20trusting%20connection&width=540&height=660&seq=story-owner-1&orientation=portrait',
  },
  {
    quote: 'Dr. Rao caught something two other clinics missed. Calm, clear, and never rushed — I actually feel like a partner in my dog\'s care now.',
    name: 'Marcus B.',
    detail: 'Pet parent to Nori, senior lab',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20warm%20man%20in%20his%2030s%20softly%20smiling%20while%20holding%20his%20senior%20black%20labrador%20dog%20outside%20a%20bright%20modern%20warm%20neighborhood%20veterinary%20clinic%20on%20a%20sunny%20day%2C%20natural%20candid%20portrait%2C%20warm%20off%20white%20background%2C%20real%20human%20animal%20bond%2C%20natural%20skin%20tones&width=540&height=660&seq=story-owner-2&orientation=portrait',
  },
  {
    quote: 'The whole team explains things without the jargon. My cat leaves purring, honestly. It never used to be like this at other clinics.',
    name: 'Sana L.',
    detail: 'Pet parent to Poppy, tuxedo cat',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20smiling%20young%20woman%20softly%20holding%20her%20tuxedo%20cat%20close%20to%20her%20cheek%20inside%20a%20bright%20warm%20modern%20veterinary%20waiting%20area%20with%20natural%20daylight%2C%20warm%20off%20white%20background%2C%20real%20human%20animal%20bond%2C%20natural%20skin%20tones%2C%20intimate%20quiet%20moment&width=540&height=660&seq=story-owner-3&orientation=portrait',
  },
];

export default function OwnerStories() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % stories.length), 6500);
    return () => clearInterval(t);
  }, []);
  const s = stories[idx];

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-container mx-auto px-5 md:px-12">
        <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">Owner Stories</div>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative w-full aspect-[4/5] overflow-hidden shape-1 bg-line">
              <img
                key={s.name}
                src={s.img}
                alt={s.name}
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:col-span-7">
            <blockquote key={s.name} className="font-display font-semibold text-[30px] md:text-[42px] leading-[1.18] text-cocoa">
              &ldquo;{s.quote}&rdquo;
            </blockquote>
            <div className="mt-8 flex items-center gap-4 text-[15px]">
              <span className="text-ink font-semibold">{s.name}</span>
              <span className="w-1 h-1 rounded-full bg-muted"></span>
              <span className="text-muted">{s.detail}</span>
            </div>

            <div className="mt-10 flex items-center gap-3">
              {stories.map((st, i) => (
                <button
                  key={st.name}
                  onClick={() => setIdx(i)}
                  aria-label={`Story ${i + 1}`}
                  className={`h-2 rounded-full transition-all cursor-pointer ${i === idx ? 'w-10 bg-cocoa' : 'w-2 bg-line hover:bg-muted/60'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}